import styled, { css } from "../../styled/index";
import { CS } from "../../styles/index";
// WRAPPERS
export const Overlay = styled("div") `
  position: absolute;
  top: ${({ top }) => top ? "30" : "0"}px;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  background: rgba(255,255,255,1);
  visibility: ${({ active }) => active ? "visible" : "hidden"};
  height: ${({ active }) => active ? "auto" : "0px"};
  display: flex;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
`;
export const Wrapper = styled("div") `
  display: flex;
  align-items: flex-start;
  flex-wrap: nowrap;
  > div {
    margin-right: 20px;
    &:last-child {
      margin-right: 0;
      padding-right: 20px;
    }
  }
`;
export const Lists = styled("div") `
  > div {
    margin-bottom: 25px;
    &:last-child {
      margin-right: 0;
    }
  }
`;
// LIST
export const List = styled("div") ` 
  position: relative;
  width: 280px;
  min-width: 280px;
  max-width: 280px;
  background: ${({ theme }) => theme.box.background};
  border-radius: 3px;
  ${CS.shadow.light.two};
`;
export const ListHeading = styled("div") `
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: relative;
  padding: 8px 10px;
  font-size: 14px;
  font-weight: 600;
  background: ${({ color }) => color};
  color: white;
  border-top-left-radius: 3px;
  border-top-right-radius: 3px;
`;
export const ListHeadingCount = styled("div") `
  background: white;
  color: ${({ theme }) => theme.box.text};
  border-radius: 10px;
  height: 16px;
  padding: 0 3px;
  line-height: 16px;
  font-size: 12px;
  font-weight: 800;
  text-align: center;
`;
// ITEM
export const ListItems = styled("div") `
  position: relative;
  > div {
    border-bottom: 1px solid ${({ theme }) => theme.box.border};
    &:last-child {
      border-bottom: none;
      border-bottom-left-radius: 3px;
      border-bottom-right-radius: 3px;
    }
  }
`;
export const ListItem = styled("div") `
  position: relative;
  background: ${({ theme }) => theme.box.background};
  ${({ isDragging }) => isDragging ? css `
    border-bottom: none !important;
    ${CS.shadow.heavy.one};
  ` : ""};
  &:hover {
    > .row-hover {
      visibility: visible;
      max-height: 50px;
    }
  }
`;
export const ListItemContent = styled("div") `
  display: flex;
  align-items: center;
  padding: 10px 10px;
  cursor: pointer;
`;
export const ListItemHover = styled("div") `
  visibility: hidden;
  transition: 0.3s max-height;
  height: auto;
  max-height: 0;
`;
export const ListItemDropdown = styled("div") `
  border-top: 1px solid ${({ theme }) => theme.box.border};
`;
export const ListItemCover = styled("div") `
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
  background: rgba(255,255,255,1);
`;
export const ListItemIcon = styled("div") `
  font-size: 20px;
  margin-right: 10px;
`;
export const ListItemEmpty = styled("div") `
  display: flex;
  align-items: center;
  justify-content: center;
  height: 80px;
  background: ${({ theme }) => theme.box.background};
`;
//# sourceMappingURL=components.js.map